@if (payments) {
  <div class="pad-top-20 row column twelve lg-push-two md-eight md-push-two">
    <div class="image-container">
      @if (payments?.length === 1) {
        <div class="flex justify-center">
          @if (feature === features.ADD_VEHICLE) {
            <img src="/assets/images/future-payments-full-pay.png" alt="future payments full pay" />
          }
          @if (feature === features.REPLACE_VEHICLE) {
            <img
              src="/assets/images/replace-vehicle-full-term.png"
              alt="future payments full pay"
            />
          }
        </div>
      }
      @if (payments?.length > 1) {
        <div class="flex justify-center">
          @if (feature === features.ADD_VEHICLE) {
            <img
              src="/assets/images/future-payments-monthly-pay.png"
              alt="future payments monthly pay"
            />
          }
          @if (feature === features.REPLACE_VEHICLE) {
            <img
              src="/assets/images/replace-vehicle-monthly.png"
              alt="future payments monthly pay"
            />
          }
        </div>
      }
    </div>
  </div>
  <div class="pad-top-20 row column twelve lg-push-two md-eight md-push-two">
    <amfam-wrap-section
      [headerContentRef]="{ path: 'policy.premiumBilling.futurePaymentHeader' }"
      iconClass="icon-calendar"
      [itemList]="payments"
    ></amfam-wrap-section>
  </div>
}
